import { Component } from "@angular/core";

@Component({
    selector: "app-azara-wrapper",
    templateUrl: "./azara-wrapper.component.html",
    styleUrl: "./azara-wrapper.component.scss",
})
export class AzaraWrapperComponent {}
